import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import AdminLayout from '../components/admin/AdminLayout';
import CoursesManagement from '../components/admin/CoursesManagement';
import SessionsManagement from '../components/admin/SessionsManagement';
import HomeworkManagement from '../components/admin/HomeworkManagement';
import StudentsManagement from '../components/admin/StudentsManagement';
import AddPythonCourse from '../components/admin/AddPythonCourse';
import AddAdvancedCourses from '../components/admin/AddAdvancedCourses';
import AddNewCourse from '../components/admin/AddNewCourse';
import InteractiveLearningManagement from '../components/admin/InteractiveLearningManagement';
import ClassroomEnhanced from '../components/classroom/ClassroomEnhanced';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.type !== 'admin') {
      navigate('/');
    }
  }, [user, navigate]);

  if (!user || user.type !== 'admin') {
    return null;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/courses" replace />} />
        <Route path="/courses" element={<CoursesManagement />} />
        <Route path="/sessions" element={<SessionsManagement />} />
        <Route path="/homework" element={<HomeworkManagement />} />
        <Route path="/students" element={<StudentsManagement />} />
        <Route path="/add-python-course" element={<AddPythonCourse />} />
        <Route path="/add-advanced-courses" element={<AddAdvancedCourses />} />
        <Route path="/add-new-course" element={<AddNewCourse />} />
        <Route path="/interactive-learning" element={<InteractiveLearningManagement />} />
        <Route path="/classroom/:sessionId" element={<ClassroomEnhanced />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminDashboard;

